Namespace 'Common.Sessions'

class Common.Sessions.TabContainerView extends Backbone.View
  template: JST['backbone/templates/common/tabs/tab_container']
  className: 'tabs-header'

  events:
    'click #new_session': 'createTab'

  initialize: ({sessions}) ->
    @sessions = sessions
    @tabViews = []
    @scrollingView = new Customer.Tabs.TabScrollingView()
    @listenTo(@sessions, 'add', @render)
    @listenTo(@sessions, 'remove', @render)
    @listenTo(@sessions, 'change:closed', @render)
    @listenTo(@sessions, 'change:focused', @scrollToSelectedTab)

  render: =>
    @$el.html(@template())
    tabView.remove() for tabView in @tabViews
    @tabViews = []
    openSessions = @sessions.getOpenSessions()
    for session in openSessions
      newTabView = new Common.Sessions.TabView(session: session, sessions: @sessions)
      @tabViews.push(newTabView)
      @$el.children('#tabs-list').append(newTabView.render().el)
    @scrollingView.setScrollableElement(@$el.find('#tabs-list'))
    @$el.find('.scrolling-buttons-container').html(@scrollingView.render().el)
    @scrollToSelectedTab()
    @

  scrollToSelectedTab: =>
    focusedTabView = @tabViews.find((view) -> view.session.get('focused'))
    @scrollingView.scrollTo(focusedTabView.$el) if focusedTabView

  createTab: =>
    @sessions.addNewSession()
